import { render } from "./BlFormFieldEmail.vue?vue&type=template&id=ef45d172"
import script from "./BlFormFieldEmail.vue?vue&type=script&lang=js"
export * from "./BlFormFieldEmail.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/4f365a42-b3f2-4061-98cc-f7413900e2b1/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__